import { Injectable } from '@angular/core';
import { AuditClaimSearchModalComponent } from '@module-claims/components/audit-claim-search-modal/audit-claim-search-modal.component';
import { DialogService } from '@progress/kendo-angular-dialog';

@Injectable()
export class AuditClaimSearchModalService {
  constructor(private _dialogService: DialogService) {}

  open(title = 'Search 340B Claims'): void {
    this._dialogService.open({
      title,
      content: AuditClaimSearchModalComponent
    });
  }
}
